<template>
  <div class="message">
    <!-- 付款二维码 -->
    <div class="giftfk" v-if="paycode" style="z-index: 121">
      <div>请用微信扫码支付</div>
      <fkcode :link="giftifo"></fkcode>
      <br />
      <span style="color: red">{{ count }}</span> 秒后自动取消
      <br />
      <br />
      <div style="color: #256ee7" @click="cancelpay()">取消支付</div>
    </div>
    <!-- 付款遮罩 -->
    <div class="mb_giftfk" v-if="paycode" style="z-index: 120"></div>
    <!-- 消息框主体 -->
    <div class="message_view1">
      <div class="lt_title">{{ title }}</div>
      <div class="message-scroll" ref="messageList">
        <div v-for="(item, index) in msgList" :key="index">
          <!-- 消息 -->
          <div class="message_item"
            v-if="item.type == 1 || item.type == 3 || item.type == 7 || item.type == 8 || item.type == 9 || item.type == 11">
            <img class="img" v-if="item.role == 4 || item.role == 0" :src="item.headUrl" alt="" />
            <img class="img" v-if="item.role == 3 || item.role == 2" src="../../assets/lives/fas.png" alt="" />
            <span v-if="item.role == 3" class="tag">助理</span>
            <span v-if="item.role == 2" class="tag">主播</span>
            <span>{{ item.srcNickname }}</span>
            <div class="test1">
              <!-- 消息框 -->
              <div class="props_msg" v-if="item.type !== 3" v-html="getdata(item.text)"></div>
              <div class="props_msg" v-if="item.type == 3">
                <img :src="item.text" @load="scrollToBottom()" />
              </div>
              <div class="replyDiv" v-if="item.msgType === 1 && item.reply">
                <span>{{ replyValue(item.reply) }}</span>
              </div>
              <a v-if="item.msgType === 4" href="item.text" target="_blank" class="props_msg">{{ item.text }}</a>
              <img :src="item.original" v-if="item.msgType === 2" style="
                  width: 100%;
                  height: 100%;
                  border-radius: 0;
                  padding: 12px 16px;
                " />
              <div class="quote" v-if="item.type == 11 || item.type == 9">@{{ item.extra }}</div>
            </div>
          </div>
          <!-- 公告消息 -->
          <div class="message_item" v-if="item.type == 16">
            <span class="user-img">公告</span>
            <span> 系统消息</span>
            <div class="test1">
              <div class="props_msg" v-html="getdata(item.text.message)"></div>
            </div>
          </div>
          <!-- 欢迎语言 -->
          <div class="message_item" v-if="item.type == 4 || item.type == 24">
            <img class="img" src="../../assets/lives/noot.png" alt="" />
            <span>系统消息</span>
            <div class="test1" v-if="item.type == 4">
              <!-- 消息框 -->
              <div class="props_msg">
                <span style="color: black">欢迎</span><span style="color: #fa5026">“{{ item.text }}”</span><span
                  style="color: black">进入直播间</span>
              </div>
            </div>
            <div class="test1" v-if="item.type == 24">
              <div class="props_msg">
                <span style="color: #fa5026">“{{ item.text.textPrefix
                }}”</span><span style="color: black">{{ item.text.textSuffix }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 快捷回复 -->
    <div class="falst_enter" v-if="show_faste_no && chatsetinfo.fastReply">
      <div v-for="(item, index) in this.chatsetinfo.fastReplyWord" @click="click_faste(item)">
        {{ item }}
      </div>
    </div>
    <!-- 输入框 -->
    <div class="input_until">
      <div class="input_message">
        <img src="../../assets/lives/expression.png" alt="" @click="click_expression" />
        <input :disabled="send_if || (roomconfig.replayFlag === 1 && roomconfig.liveStatus !== 'living')" type="text"
          :placeholder="send_if ? '全体禁言中' : (roomconfig.replayFlag === 1 && roomconfig.liveStatus !== 'living') ? '回放中无法互动' : '说点什么吧~'"
          v-model="sendText" adjust-position="false" confirm-type="send" @confirm="Livesend(sendText, 1)"
          @keyup.enter="Livesend(sendText, 1)" @focus="show_faste(true)" @blur="show_faste(false)" ref="inputdata" />
        <div class="sendBtn" @click="Livesend(sendText, 1)" :disabled="send_if">
          发送
        </div>
      </div>
    </div>

    <!-- 按钮 -->

    <el-collapse-transition>
      <div class="col_until">
        <div style="text-align: center;" @click="checkCoupon()"
          v-if="coupon.text.timeOut - new Date().getTime() > 0 || coupon.text.timeOut == -1">
          <img src="../../assets/lives/coupon.png"> </img>
          <countdown v-if="(coupon.text.timeOut - new Date().getTime()) > 0" @countdown_show="countdown_show" type="2"
            :endTime="coupon.text.timeOut" style="color: #ff701d;">
          </countdown>
        </div>

        <img v-if="commodityList.length != 0" src="../../assets/lives/commodity.png" alt="" title="热销商品"
          @click="clickcommodity" />
      </div>
    </el-collapse-transition>

    <!-- 表情 -->
    <div class="expression" v-if="showexpression">
      <div v-for="(item, index) in 29">
        <img :src="facelist['smiley_' + (index + 1)]" style="
            width: 24px;
            height: 24px;
            float: left;
            margin-left: 20px;
            margin-top: 20px;
          " @click="sendFace(index + 1)" />
      </div>
    </div>
    <!-- 异地登录 -->
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="20%" @close="clearlogin" center>
      <div style="text-align: center">
        <span>您的账户已在另一设备上登录。如果这不是您本人，请检查账户安全。</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearlogin">取 消</el-button>
        <el-button type="primary" @click="delwatchtype" style="margin-left: 50px">重新登录</el-button>
      </span>
    </el-dialog>
    <!-- 签到 -->
    <!-- <sign ref="sign"></sign> -->

    <!-- 抢购弹窗 -->
    <!-- <recommend @excitrecommend="excitrecommend" v-if="show_recommend" :recommend_info="recommend_info"
      @recommendSucess="recommendSucess" :buyButtonText="buyButtonText" :productSoldOutDesc="productSoldOutDesc">
    </recommend> -->
    <card v-if="cardFalg" :cardDate="cardDate" @close="cardFalg = false" title="卡片"></card>
    <orderControl v-if="orderControlFlag" :orderDate="orderDate" title="订单场控"></orderControl>
    <applyControl v-if="applyControlFlag" :applyDate="applyDate" @close="applyControlFlag = false" title="报名场控">
    </applyControl>
    <treasureBox v-if="treasureBoxFalg" :treasureBoxFalg="treasureBoxFalg" :isEndTreasure="isEndTreasure"
      @close="treasureBoxFalg = false" title="宝箱"></treasureBox>
    <draw v-if="drawFalg" :drawDate="drawDate" @close="drawFalg = false" title="抽奖"></draw>
    <!-- 拉黑弹窗 -->
    <div class="blackpopup" v-if="visibleBlack">
      <div style="display: flex; justify-content: center">
        <img style="width: 552px" src="../../assets/lives/zd.png" mode="widthFix" />

        <div>
          <img style="width: 26px; flex-shrink: 0" src="../../assets/lives/tips.png" mode="widthFix" />
        </div>

        <div>
          <div class="">抱歉，页面内容走丢了...</div>
          请联系管理员
        </div>
      </div>
    </div>
    <!-- 抢券 -->
    <Coupon v-if="showCoupon" @close="visibileCoupon(false)" @useCoupon="useCoupon">
    </Coupon>

    <!-- 精选消息 -->
    <div class="featureMessage" style="position: absolute;top: 48px;left: 0px;z-index: 1000;"
      v-if="featureMessage.type == 11 || featureMessage.type == 1">
      <div class="flex">
        <div style="display: flex;align-items: center;">
          <img style="width: 28px;" src="../../assets/lives/yh.png" mode="widthFix">
          <span v-if="featureMessage.type == 11"
            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 250px; color: #b7b7b7;">@{{
              featureMessage.extra }}</span>
          <span v-if="featureMessage.type == 1"
            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px; color: #B4E2F1;">{{
              featureMessage.srcNickname }}</span>
        </div>
        <img style="width: 20px;" src="../../assets/lives/riLine-close.png" mode="widthFix"
          @click="featureMessage.type = ''">
      </div>
      <div class="featureMessage-title">{{ featureMessage.text }}</div>
    </div>
    <channelpopup ref="channelpopup"></channelpopup>
  </div>
</template>

<script>
import face from "@/utils/face";
import Base64 from "@/utils/Base64";
import fkcode from "./fkcode.vue";
import com_icon from "@/assets/lives/commodity.png";
import { mapState } from "vuex";
import card from "./card.vue";
import orderControl from "./orderControl.vue";
// import recommend from "./recommend.vue";
import applyControl from "./applyControl.vue";
import notice from "./notice.vue";
import sign from "./sign.vue";
import Coupon from "./coupon.vue";
// import commodity from './commodity.vue';
import treasureBox from "./treasureBox.vue";
import draw from "./draw.vue";
import countdown from "@/components/lives/countdown.vue";
import channelpopup from "./channelpopup.vue";
var Live;
let userCountInterval;
export default {
  name: "message",
  props: {
    liveStatus: {
      type: String,
      default: "living",
    },
    roomconfig: Object,
    // imHttpServerUrl: {
    //   type: String,
    //   default: "http://login.tdnstic1.cn:8071",
    // },
    title: {
      type: String,
      default: "互动聊天",
    },
    buyButtonText: {
      type: String,
      default: "立即抢购",
    },
    productSoldOutDesc: {
      type: String,
      default: "已售罄",
    },
  },
  components: {
    fkcode,
    card,
    orderControl,
    applyControl,
    treasureBox,
    draw,
    Coupon,
    countdown,
    // recommend,
    notice,
    sign,
    channelpopup,
  },
  created() {
    // this.Live = new VendorChat.LIM(this.roomconfig.merchantConfigDetailDTO.imHttpServerUrl)
  },
  mounted() {


  },
  data() {
    return {
      user: {
        accountId: "",
        token: "",
        account: "",
        nickName: "",
        phoneNumber: "",
        roomId: "",
        role: 4,
        netType: 1,
        Platform: 4, // uint32, 1 android, 2 iOS, 3 windows, 4 web
        systemOS: "web",
        channel: "web",
        headPicUrl: localStorage.getItem("user_headimg"),
      },
      centerDialogVisible: false,
      show_icon_rec: false,
      msgList: [],
      sendText: "",
      headUrl: localStorage.getItem("user_headimg"),
      nickname: "",
      facelist: face.face,
      showexpression: false,
      giftscroll: 0,
      giftlist: [],
      showgift: false,
      giftifo: {},
      paycode: false,
      time: "",
      count: 60,
      times: null,
      rtcStatus: 0,
      trtc_wait: 60,
      trtc_wait_in: null,
      trtc_time: {
        sec: 0,
        min: 0,
      },
      trtc_time_in: null,
      qd_info: {},
      show_qd: true,
      qd_time: null,
      qd_count: 0,
      qd_type: 0,
      tx_img: "",
      tx_view: false,
      tx_list: [],
      chatsetinfo: {
        fastReplyWord: ["仙湖", "fasfd"],
      },
      historyparm: {
        index: 0, //索引，非页码
        count: 20, //条数
        msgType: 1, //消息类型 1-聊天消息
      },
      show_faste_no: true,
      show_kj: false,
      kj_url: "",
      send_if: false,
      show_recommend: false,
      recommend_info: {},
      commodityListIcon: com_icon,
      show_redtips: true,
      roomdid: "",
      // 卡片
      cardFalg: false,
      cardDate: {},
      // 报名场控
      applyControlFlag: false,
      applyDate: {},
      // 订单场控
      orderControlFlag: false,
      orderDate: {},
      // 抽奖
      drawFalg: false,
      drawDate: {},
      // 宝箱
      treasureBoxFalg: false,
      treasureBoxDate: {},
      isEndTreasure: false,
      Live: null,
      msgFlag: true,
      shownotice: false,
      showCoupon: false,
      showGoods: false,
      show_countdown: false,
      selTab: 1,
      noticeMessage: {},
      visibleBlack: false,
      wordList: [],
      CouponMessage: {
        "srcId": 0,
        "type": 21,
        "noticeTime": 1744103156,
        "messageId": 7796,
        "text": {
          "couponName": "门店鸡蛋10盒领取券",
          "couponAmt": 100,
          "issuanceId": 75,
          "couponDesc": "无门槛优惠券",
          "couponId": 8,
          "timeOut": 1744103456632
        }
      },
      featureMessage: {
        "role": 3, "srcId": 1393983360, "extra": "", "headUrl": "", "chatTime": 1748397474,
        "messageId": 442394, "srcNickname": "", "channelName": "", "text": "", "type": 0, "channelId": 0
      }
      // showSign: true,
    };
  },
  computed: {
    replyValue() {
      return (value) => {
        return value ? value.srcNickname + ":" + value.text : "";
      };
    },
    ...mapState({
      commodityList: (state) => state.commodityList,
      coupon: (state) => state.coupon,
    }),
  },
  beforeDestroy() {
    // if (this.Live) {
    //     this.Live.logout();
    // }
  },
  methods: {
    // 聊天登录
    async socketLogin() {
      let random = Math.floor(Math.random() * 10000) + 10000
      let _this = this
      this.user.nickName = (_this.roomconfig.enterType == "FREE" || _this.roomconfig.enterType == "FREE_VIP") ? localStorage.getItem("live_nick_name") : localStorage.getItem("user_name");
      this.Live = new VendorChat.LIM("http://login.tdnstic1.cn:8071");
      const res = await this.$liveapi.loginIm({
        role: 4,
        roomId: this.roomconfig.roomId,
      });
      sessionStorage.setItem('uid', res.data.data.uid)
      _this.$tracker.send({ content: { random: random, ...res.data.data } })
      this.user.token = res.data.data.token;
      this.user.account = res.data.data.token;
      this.user.roomId = this.roomconfig.roomId;
      this.user.accountId = res.data.data.accountId;
      // 获取免审词 
      this.$liveapi.getfreepassword({ roomId: this.roomconfig.roomId }).then((res) => {
        _this.wordList = res.data.data.wordList
      });
      // 获取敏感词
      this.$liveapi.getSensitiveWord({ roomId: this.roomconfig.roomId }).then((res) => {
        _this.sensitiveWordList = res.data.data.wordList
      });

      if (this.Live.getLoginStatus() == 0) {
        this.Live.login2(
          {
            gateKey: res.data.data.token,
            account: res.data.data.account,
            nickname: res.data.data.nickname,
            userId: res.data.data.uid,
            gateAddr: res.data.data.gateaddr,
          },
          function (user) {
            if (user.code == 404) {
              _this.visibleBlack = true;
              _this.$emit("stoplive");
              clearInterval(userCountInterval);
            } else if (user.code == 200) {
              _this.Live.onGroupMsg(_this.onMsg);
              // 接收通知消息
              _this.Live.onNoticeMsg(_this.onNoticeMsg);
              // 异地登陆
              _this.Live.onForceLogout(_this.onForceLogout);
              // 获取历史消息

              if (_this.roomconfig.replayFlag !== 1 && _this.roomconfig.liveStatus !== 'living') {
                _this.Live.getHistoryMessagesList({}, function (resp) {
                  console.log('resp', resp)

                  if (resp.total > 0) {
                    const filtered = resp.list.filter(
                      (message) => message.extra !== "mg" && message.type !== 4
                    );
                    _this.msgList = [];
                    (async () => {
                      for (const message of filtered) {
                        if (_this._isDestroyed) return;
                        const embedded9 = _this.parseEmbeddedChatFromExtra(
                          message.extra
                        );
                        if (
                          message.type === 9 &&
                          embedded9 &&
                          embedded9.type === 8
                        ) {
                          const inner = { ...embedded9 };
                          const delayed = {
                            ...message,
                            extra: _this.formatType9ExtraForDisplay(message.extra),
                          };
                          const uid = sessionStorage.getItem("uid");
                          const skipInner =
                            uid != null &&
                            String(inner.srcId) === String(uid);
                          if (!skipInner) {
                            if (_this.msgList.length >= 100) _this.msgList.shift();
                            _this.msgList.push(inner);
                            _this.scrollToBottom();
                          }
                          await new Promise((r) => setTimeout(r, 2000));
                          if (_this._isDestroyed) return;
                          if (_this.msgList.length >= 100) _this.msgList.shift();
                          _this.msgList.push(delayed);
                        } else if (
                          message.type === 9 &&
                          embedded9 &&
                          embedded9.type === 1
                        ) {
                          if (_this.msgList.length >= 100) _this.msgList.shift();
                          _this.msgList.push({
                            ...message,
                            extra: _this.formatType9ExtraForDisplay(message.extra),
                          });
                        } else {
                          if (_this.msgList.length >= 100) _this.msgList.shift();
                          _this.msgList.push(message);
                        }
                        _this.scrollToBottom();
                      }
                      console.log("msgList", _this.msgList);
                    })();
                  }
                });
                // 发送欢迎语
                if (_this.roomconfig.loginWelcomeFlag === 1) {
                  _this.Livesend(_this.user.nickName, 4);
                }
              }
              _this.Live.onRecallMsg(_this.onRecallMsg);
              _this.getRoomLiveStatus();
              _this.initRoomStatus();
              userCountInterval = setInterval(function () {
                _this.userCount();
              }, 30000);

            } else if (user.code == 400) {
              window.location.reload()
            } else {
              if (user.code == 6) {
                return
              }
              _this.$tracker.send({ content: { random: random, ...user, message: 'IM的第一个回调函数,code不等于200和400' } })
              alert('IM登录失败code:' + random)
            }
          },
          function (resp) {
            _this.$tracker.send({ content: { random: random, ...res.data.data, im: resp, message: 'IM的第二个回调函数登录异常' } })
            alert('IM登录失败code:' + random)
          }
        );
      }
      // 设置禁言
      this.nosms(this.roomconfig.overallMuteFlag === 1 ? true : false);
      this.getCouponIngByRoom()
      // 设置登录欢迎语
      // this.getSign();
    },
    //发送消息  type为 1 需要插入
    Livesend(msg, type) {
      // 不能发言
      let _this = this;
      if (!this.msgFlag) {
        this.$message({
          message: "发言太快啦，休息一下",
          type: "warning",
        });
        return;
      }
      this.msgFlag = false;
      let sleep = setTimeout(() => {
        _this.msgFlag = true;
        clearTimeout(sleep);
      }, 1000);

      if (msg.trim() == "") return;
      if (msg.trim().length > 200) {
        this.$message({
          message: "消息超出200个字符",
          type: "warning",
        });
        return;
      }
      let data = {
        type: type,
        text: msg.trim(),
      };
      // 免审词
      if (type == 1) {
        if (
          this.roomconfig.messageAutoPassFlag === 1 &&
          this.wordList.includes(msg.trim())
        ) {
          data.type = 7;
        }
        const filteredList = this.sensitiveWordList.filter((word) => word.trim() !== "");
        if (filteredList.some((word) => msg.trim().includes(word))) {
          data.type = 6;
        }
      }
      if (type == 4) {
        data.extra = 'w'
      }
      this.Live.sendGroupTextMessage(data, function (resp) {
        if (_this.msgList.length >= 100) {
          _this.msgList.shift();
        }
        _this.msgList.push({
          type: type,
          headUrl: localStorage.getItem("user_headimg"),
          role: 4,
          srcNickname: _this.user.nickName,
          text: msg.trim(),
        });
        _this.sendText = "";
      });
    },

    // type=9 的 extra 为 JSON 时：type=8 先当普通消息插入再延迟插入回复；type=1 仅把 extra 格式化为 srcNickname:text 一条消息
    parseEmbeddedChatFromExtra(extra) {
      if (extra == null || typeof extra !== "string") return null;
      const t = extra.trim();
      if (!t.startsWith("{")) return null;
      try {
        const o = JSON.parse(t);
        if (o && (o.type === 8 || o.type === 1)) return o;
      } catch (e) {
        return null;
      }
      return null;
    },
    formatType9ExtraForDisplay(extra) {
      const embedded = this.parseEmbeddedChatFromExtra(extra);
      if (embedded) {
        const nick =
          embedded.srcNickname != null ? String(embedded.srcNickname) : "";
        const text = embedded.text != null ? String(embedded.text) : "";
        return `${nick}:${text}`;
      }
      return extra;
    },
    // 插入消息
    onMsg(data) {
      console.log("普通消息", data);
      if ("extra" in data && data.extra == "mg") return;
      const embedded9 = this.parseEmbeddedChatFromExtra(data.extra);
      if (data.type === 9 && embedded9 && embedded9.type === 8) {
        const inner = { ...embedded9 };
        const delayed = {
          ...data,
          extra: this.formatType9ExtraForDisplay(data.extra),
        };
        const uid = sessionStorage.getItem("uid");
        const skipInner =
          uid != null && String(inner.srcId) === String(uid);
        if (!skipInner) {
          if (this.msgList.length >= 100) this.msgList.shift();
          this.msgList.push(inner);
          this.scrollToBottom();
        }
        setTimeout(() => {
          if (this._isDestroyed) return;
          if (this.msgList.length >= 100) this.msgList.shift();
          this.msgList.push(delayed);
          this.scrollToBottom();
        }, 2000);
        return;
      }
      if (data.type === 9 && embedded9 && embedded9.type === 1) {
        if (this.msgList.length >= 100) this.msgList.shift();
        this.msgList.push({
          ...data,
          extra: this.formatType9ExtraForDisplay(data.extra),
        });
        this.scrollToBottom();
        return;
      }
      if (this.msgList.length >= 100) {
        this.msgList.shift();
      }
      this.msgList.push(data);
    },
    // roomconfig
    onNoticeMsg(msg) {
      console.log('通知消息', msg)
      if (this.msgList.length >= 100) {
        this.msgList.shift();
      }
      //公告消息
      let messag = {};
      if (msg.type !== 19 && msg.type != 22) {
        messag = { ...msg, text: JSON.parse(msg.text) };
      }
      if (msg.type == 16) {
        if (messag.text.showStyle == "message") {

          this.msgList.push(messag);
        }
        if (messag.text.showStyle == "pop") {
          if (messag.text.sendTime == 0 || !('sendTime') in messag.text) {
            messag.text.sendTime = new Date().getTime()
          }
          this.msgList.push(messag);
          this.$emit("openNotice", messag);
          // this.noticeMessage = messag;
          // this.visibileNotice(true);
        }
      }
      if (msg.type == 24) {
        this.msgList.push({ type: 24, text: JSON.parse(msg.text) })
      }
      // 上架
      if (msg.type == 10) {
        this.$store.commit("saleCommodityList", JSON.parse(msg.text));
      }
      // 下架
      if (msg.type == 12) {
        this.$store.commit("unSaleCommodityList", JSON.parse(msg.text).productId);
        if (messag.text.spuId == this.recommend_info.productId) {
          this.$emit("excitrecommend", false);
        }
      }
      // 推荐
      if (msg.type == 13) {
        let recommend = JSON.parse(msg.text);
        let exts = JSON.parse(recommend.exts);
        if ("timeOut" in exts) {
          recommend.endTime = exts.timeOut;
        }
        if ("heat" in exts) {
          recommend.heat = exts.heat;
        }
        recommend.sendTime = exts.sendTime;
        if ('styleType' in exts) {
          recommend.styleType = exts.styleType
        } else {
          recommend.styleType = 1
        }
        this.recommend_info = recommend;
        this.$emit("recommend_dec", recommend);
        this.$store.commit("recommendIng", recommend);
      }
      // 取消推荐
      if (msg.type == 15) {
        this.$store.commit("unRecommendIng", JSON.parse(msg.text).productId);
        this.$emit("excitrecommend", false);
      }
      // 售罄
      if (msg.type == 11) {
        this.$store.commit("sellOut", {
          productId: JSON.parse(msg.text).productId,
          status: "selloutIng",
        });
        if (messag.text.spuId == this.recommend_info.productId) {
          this.recommend_info = {
            ...this.recommend_info,
            productSellOutStatus: "selloutIng",
          };
          this.$emit("recommend_dec", this.recommend_info);
        }
      }
      // 补货
      if (msg.type == 14) {
        this.$store.commit("sellOut", {
          productId: JSON.parse(msg.text).productId,
          status: "unsellout",
        });
        if (messag.text.spuId == this.recommend_info.productId) {
          this.recommend_info = {
            ...this.recommend_info,
            productSellOutStatus: "unsellout",
          };
        }
      }
      // 签到消息
      if (msg.type == 18) {

        this.$emit('showSign', JSON.parse(msg.text))
      }
      // 结束签到
      if (msg.type == 19) {
        this.$emit('closeSign')
      }
      // 开播状态
      if (msg.type == 20) {
        this.$emit("openLive", msg.text);
      }
      // 优惠券消息
      if (msg.type == 21) {
        this.$store.commit("set_coupon", {
          ...messag,
          status: 1
        })
        this.visibileCoupon(true)
      }
      // 停止发放优惠券
      if (msg.type == 22) {
        this.$store.commit("set_coupon", {
          "text": {
            "couponName": "",
            "couponAmt": null,
            "issuanceId": null,
            "couponDesc": "",
            "couponId": null,
            "timeOut": null
          }
        })
        this.visibileCoupon(false)
      }
      if (msg.type == 23) {
        this.$store.commit("set_coupon", {
          ...messag,
          status: messag.text.type == "use" ? 3 : 1
        })
        this.visibileCoupon(true)
      }
      // 精选消息
      if (msg.type == 26) {
        this.featureMessage = messag.text
      }
      // 渠道加微
      if (msg.type == 29) {
        if (!('accountId' in messag.text) || messag.text.accountId == this.user.accountId) {
          this.$refs.channelpopup.open(messag.text)
        }
      }
    },
    // 异地登录
    onForceLogout(data) {
      if (data.errorCode == VendorChat.Code.ErrorCodeReLogin) {

        let cid = localStorage.getItem(`${this.$route.params.id}c_id`)

        localStorage.removeItem(`user_token_${cid}`)


        this.centerDialogVisible = true;
      }
      if (data.errorCode == VendorChat.Code.ErrorCodeBlackUserKickout) {
        // alert("用户被加入黑名单");
        this.visibleBlack = true;
      }

      if (data.errorCode == VendorChat.Code.ErrorCodeUserKickout) {
        this.visibleBlack = true;
      }
      this.$emit("liveForceLogout");
    },
    // 直播间开播状态
    getRoomLiveStatus() {
      let _this = this;
      this.Live.getRoomLiveStatus({}, function (resp) {
        if (resp.status == 1) {
          _this.$liveapi.fillBaseUser({ termId: _this.roomconfig.termId }).then(res => {
            console.log('开播上报', res)
          })
        }
      });
    },
    // 消息撤回
    onRecallMsg(resp) {
      let index = this.msgList.findIndex(
        (item) => item.messageId === resp.messageId
      );
      if (index !== -1) {
        this.msgList.splice(index, 1);
      }
    },
    // 用户数
    userCount() {
      let _this = this;
      this.Live.getRoomOnlineMemberCount({}, function (resp) {

        _this.$emit("ImUserNumber", resp.userCount);
      });
    },
    // 获取直播间状态（禁言等），主动拉取一次并监听变更
    initRoomStatus() {
      let _this = this;
      // getRoomInfos: { checkStatus, muteStatus, rtcStatus, selfVisibleStatus }
      this.Live.getRoomInfos({}, function (resp) {
        _this.applyRoomStatus(resp);
      });
      // onRoomStatus: { mute?, rtcStatus? }，mute 可能不存在
      this.Live.onRoomStatus(function (resp) {
        _this.applyRoomStatus(resp);
      });
    },
    applyRoomStatus(resp) {
      if (!resp) return;
      // 主动拉取用 muteStatus，推送通知用 mute
      if ("muteStatus" in resp) {
        this.nosms(!!resp.muteStatus);
      } else if ("mute" in resp) {
        this.nosms(!!resp.mute);
      }
      if ("rtcStatus" in resp) {
        this.rtcStatus = resp.rtcStatus;
      }
    },

    countdown_show(status) {
      this.show_countdown = status;
    },
    //接受消息

    //监听主播端是否同意上麦
    //监听禁言操作
    //监听主播端邀请连麦请求
    //监听主播端下麦请求

    //昵称格式化
    gsnickname(val) {
      var msgname = val;
      msgname = msgname.replace(/\d{8,}/g, "*");
      msgname = msgname.length > 8 ? msgname.substring(0, 8) + "..." : msgname;
      return msgname;
    },
    // 表情包序列化
    getdata(text) {
      const regex = /\[s(\d+)\]/g;
      return text.replace(regex, (match, index) => {
        // 替换为相应的HTML代码
        let img = this.facelist[`smiley_${index}`];
        return `<img src="${img}" style="width: 24px;height: 24px;vertical-align:middle"/>`;
      });
    },

    //禁言
    nosms(status) {
      this.send_if = status;
    },
    // 打开商品列表
    clickcommodity() {
      this.$emit("clickcommodity", true);
    },

    // 推荐
    clickrecommend() {
      this.show_recommend = true;
    },

    //聚焦事件
    show_faste(val) {
      if (!val) {
        setTimeout(() => {
          this.show_faste_no = val;
        }, 200);
      } else {
        this.show_faste_no = val;
      }
    },
    //点击快捷回复
    click_faste(val) {
      this.sendText = val;
      if (val == "鲜花") {
        this.sendText == "[s29]";
      }
    },
    // //获取商品入口图标
    // recommend_icon() {
    //     this.$api.getCommodityListIcon().then(res => {
    //         if (res.data.data.commodityListIcon == 1) {
    //             this.commodityListIcon = res.data.data.commodityListImageUrl
    //         }
    //     })
    // },

    //获取累计观看人数
    getlookbase() {
      this.$api.getlookbase().then((res) => { });
    },

    excitrecommend(val) {
      this.show_recommend = val;
    },
    //送礼物
    givegift(val) {
      this.showgift = false;
      var that = this;
      if (val.giftPrice != 0) {
        this.$api.createpcorderbygift(val.id).then((res) => {
          var num = res.data.data.orderNum;
          this.giftifo = res.data.data.url;
          this.paycode = true;
          this.times = setInterval(() => {
            this.wxcheckorder(num);
          }, 2000);
        });
        this.time = setInterval(() => {
          if (this.count <= 0) {
            clearInterval(this.time);
            clearInterval(this.times);
            this.count = 60;
            this.paycode = false;
            return;
          }
          --this.count;
        }, 1000);
      } else {
        var stext =
          '{"nickName":"' +
          Live.getLoginUser().nickname +
          '","giftName":"' +
          val.giftName +
          '","giftPicUrl":"' +
          val.giftPicUrl +
          '","notifyType":"5"}';
        var data = {
          text: stext,
          type: 3,
        };
        data.extra = {
          headUrl: this.headUrl,
          role: 4,
        };
        var msg = {
          type: 3,
          sendTime: new Date().getTime(),
          extra: {
            headUrl: this.headUrl,
          },
          srcNickname: _this.user.nickName,
          text: JSON.parse(stext),
        };
        if (
          localStorage.getItem("iswx") == 0 &&
          localStorage.getItem("logtpye") == 4
        ) {
          msg.srcNickname = localStorage.getItem("user_name1");
        }
        if (this.msgList.length >= 100) {
          this.msgList.shift();
        }
        this.msgList.push(msg);
        data.extra = JSON.stringify(data.extra);
        Live.sendMsg(data, function (ack) {
          that.tx_list.push(val.giftPicUrl);
          if (ack.code === 200) {
            setTimeout(() => {
              var message_view = document.querySelector(".message_view1");
              message_view.scrollTo(0, message_view.scrollHeight * 800);
            }, 200);
          }
        });
      }
    },
    //定时检查礼物特效
    check_tx() {
      var checknumber = setInterval(() => {
        if (this.tx_list.length != 0) {
          this.oderby_tx();
          clearInterval(checknumber);
        }
      }, 300);
    },
    //排队显示特效
    oderby_tx() {
      this.tx_gift(this.tx_list[0]);
      this.tx_list = this.tx_list.splice(1, 1);
      setTimeout(() => {
        var oderbynumber = setInterval(() => {
          if (this.tx_list[0]) {
            this.tx_gift(this.tx_list[0]);
            this.tx_list = this.tx_list.splice(1, 1);
          } else {
            clearInterval(oderbynumber);
            this.check_tx();
          }
        }, 1200);
      }, 100);
    },
    //礼物特效
    tx_gift(val) {
      this.tx_view = true;
      this.tx_img = val;
      var gifttx = document.querySelector(".gift_tx img");
      gifttx.style.width = "20px";
      gifttx.style.height = "20px";
      setTimeout(() => {
        gifttx.style.transform = "scale(5)";
        gifttx.style.transition = "all 1s";
      }, 100);
      setTimeout(() => {
        this.tx_view = false;
        gifttx.style.transform = "scale(1)";
      }, 1100);
    },
    //登出聊天
    logoutlive() {
      Live.logout();
    },
    //检查订单状态
    wxcheckorder(val, url) {
      this.$api.wxcheckorder(val).then((res) => {
        if (res.data.data.stats == 1) {
          clearInterval(this.times);
          clearInterval(this.time);
          this.paycode = false;
          this.count = 60;
          this.$message({
            message: "支付成功",
            type: "success",
          });
        }
      });
    },

    cancelpay() {
      this.count = 60;
      this.paycode = false;
      clearInterval(this.time);
      clearInterval(this.times);
    },

    sendFace(e) {
      if (!this.send_if) {
        var that = this;
        var sendText = this.sendText + "[s" + e + "]";
        that.sendText = sendText;
      }
    },

    //表情弹窗
    click_expression() {
      if (this.roomconfig.overallMuteFlag === 1) {
        return;
      }
      this.showexpression = this.showexpression ? false : true;
      this.showgift = false;
    },

    // 异地登录提示
    delwatchtype() {
      localStorage.clear();
      location.reload();
    },

    clearlogin() {
      localStorage.clear();
      location.reload();

      // this.centerDialogVisible = false;

    },
    //互动次数上报
    addMsgCount() { },
    //推荐商品支付成功回调
    recommendSucess() {
      this.show_recommend = false;
    },
    // 消息滚动
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageList;
        container.scrollTop = container.scrollHeight;
      });
    },
    // 关闭显示弹窗通知
    visibileNotice(type) {
      this.shownotice = type;
    },
    // 抢券
    visibileCoupon(visible) {
      this.showCoupon = visible
    },
    // 使用优惠
    useCoupon(val) {
      this.showCoupon = false
      this.showGoods = true
      this.selTab = val
    },

    // 获取优惠券发放状态 
    getCouponIngByRoom() {
      let _this = this
      this.$liveapi.getCouponIngByRoom({
        sceneId: this.roomconfig.roomId
      }).then(res => {
        if (res.data.code == 0 && res.data.data != '') {
          _this.$store.commit("set_coupon", {
            text: JSON.parse(res.data.data),
            status: 1
          })
        }
      })
    },

    // 校验是否已经领券
    checkCoupon() {
      let _this = this
      this.$liveapi.checkCoupon({
        couponId: this.coupon.text.couponId,
        issuanceId: this.coupon.text.issuanceId,
        sceneId: this.roomconfig.roomId,
        sceneType: 'room'
      }).then(res => {
        if (res.data.code == 90012) {
          // 修改store中 status值
          _this.$store.commit("set_coupon", {
            text: {
              ..._this.coupon.text,
              message: res.data.msg
            },
            status: 3
          })
        }
        _this.visibileCoupon(true)
        // this.$emit('close')
        // this.$emit('close')
      }).catch(err => {
        console.log(err)
      })
    },
  },
  watch: {
    msgList(newVal) {
      // 每当消息列表更新时，滚动到底部
      this.scrollToBottom();
    },
    // roomconfig(newVal) {

    // }
  },
};
</script>
<style scoped lang="scss">
.message {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fafafa;
  border-radius: 5px;

  .featureMessage {
    color: #F4F6FA;
    background: rgba(0, 0, 0, 0.66);
    border-radius: 10px;
    padding: 10px;
    font-size: 14px;

    .flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .featureMessage-title {
      padding: 0 28px;
      margin-top: 5px;
      text-align: left;
    }
  }
}

.title_msg {
  padding-top: 18px;
  height: 5%;
  font-size: 16px;
  color: #256ee7;
  font-weight: 550;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
}

.expression {
  position: absolute;
  bottom: 48px;
  overflow-y: scroll;
  z-index: 99;
  background-color: #fafafa;
  width: 100%;
  height: 37%;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.4);
}

.expression::-webkit-scrollbar {
  width: 0px;
}

.showgift {
  width: 100%;
  max-height: 320px;
  position: absolute;
  z-index: 99;
  bottom: 12%;
  background-color: #f2f2f2;
}

.showgift>.showgift_1 {
  float: left;
  margin-top: 4%;
  margin-left: 2%;
  width: 5%;
  height: 90%;
  overflow: hidden;
}

.showgift>.showgift_1>img {
  width: 90%;
  height: 20%;
  margin-top: 200%;
}

.list_gift {
  width: 90%;
  max-height: 320px;
  overflow-y: scroll;
  margin: 0 auto;
  text-align: center;
}

.list_gift::-webkit-scrollbar {
  width: 0px;
}

.list_gift>div {
  float: left;
  overflow: hidden;
  margin-left: 2%;
  margin-top: 7%;
  width: 18%;
  height: 75px;
  font-size: 12px;
  color: #777777;
  border-radius: 5px;
}

.list_gift>div:hover .btn_song span:first-child {
  display: none;
}

.btn_song>span {
  font-size: 12px;
  height: 27px;
  line-height: 27px;
  display: block;
}

.btn_song>span:nth-child(2) {
  width: 100%;
  height: 22px;
  /* background: #FF506F; */
  border-radius: 5px;
  line-height: 22px;
  opacity: 1;
  color: white;
}

.list_gift img {
  display: block;
  margin: auto;
  margin-top: 4px;
  width: 70%;
  height: 60%;
}

.line_title {
  width: 100%;
  height: 3px;
  margin: 4px auto;
  background-color: #256ee7;
  border-radius: 2px;
}

.message_view1 {
  padding-bottom: 68px;
  height: 100%;
  width: 100%;
  box-sizing: border-box;

  border-color: #f1f2f6;
}

.message-scroll {
  height: calc(100% - 48px);
  padding-bottom: 20px;
  overflow-y: scroll;
}

.message_view1::-webkit-scrollbar {
  width: 0px;
}

.message_item {
  margin: 0 auto;
  margin-top: 24px;
  width: 80%;
  text-align: left;

  .tag {
    width: 32px;
    height: 18px;
    font-size: 12px;
    color: #ffffff;
    display: inline-block;
    line-height: 18px;
    text-align: center;
    background: #E53256;
    border-radius: 3px;
  }
}

.test1 {
  word-break: break-word;

  .quote {
    padding: 7px;
    background: #eee;
    border-radius: 6px;
    color: #666;
    margin-top: 10px;
    padding-right: 25px;
    position: relative;
    font-size: 12px;
    margin-left: 37px;
  }
}

#iframe_view {
  height: 100%;
}

.message_item .img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: top;
}

.message_item span {
  font-size: 12px;
  margin-left: 8px;
  color: #999999;
}

.input_until {
  width: 100%;
  position: absolute;
  background: #f5f8fc;
  bottom: 0;
  height: 54px;
  /* box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.1); */
  /* border-radius: 0px 0px 5px 5px; */
  z-index: 98;
  display: flex;
  align-items: center;
}

.input_until>div {
  text-align: left;
}

.input_until>div img {
  cursor: pointer;
}

.props_msg {
  display: inline-block;
  /* width: 65%; */
  margin-left: 37px;
  font-size: 13px;
  padding: 12px 16px;
  background: #ffffff;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0px 5px 5px 5px;




}

.not_live_kj {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  padding-top: 9vh;
  top: 0;
  z-index: 50;
  background-size: 100%;
  height: 16vh;
}

.input_until>div:first-child img {
  float: left;
  height: 24px;
  width: 24px;
  /* margin-left: 16px; */
  /* margin-top: 8px; */
}

.until_box {
  float: right;
  margin-right: 20px;
}

.input_message {
  height: 36px;
  width: 100%;
  /* background: #fff; */
  display: flex;
  align-items: center;
  padding-left: 14px;
}

.input_message input {
  width: 60%;
  height: 32px;
  line-height: 32px;
  background: #e8e8e8;
  border: 0;
  outline: none;
  font-size: 14px;
  margin-left: 14px;
  padding-left: 26px;
}

.input_message .sendBtn {
  float: left;
  width: 19%;
  height: 32px;
  line-height: 32px;
  background: linear-gradient(153deg, #405df5 0%, #694ec4 96%);
  border-radius: 0px 4px 4px 0px;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
}

.col_until {
  position: absolute;
  bottom: 92px;
  right: 14px;
  width: 50px;
  /* height: 208px; */
}

.col_until img {
  width: 50px;
  height: 50px;
  // margin-bottom: 16px;
  cursor: pointer;
}

.user_label {
  display: inline-block;
  margin-left: 10px;
  color: #ffffff;
  font-size: 10px;
  width: 32px;
  height: 18px;
  text-align: center;
  line-height: 18px;
  /* background: linear-gradient(314deg, #377FF7 0%, #44B0FF 100%); */
  background: linear-gradient(153deg, #405df5 0%, #694ec4 96%);

  border-radius: 2px 2px 2px 2px;
}

.hands_state {
  position: absolute;
  bottom: 115px;
  right: 20px;
}

.hands_state2 {
  position: absolute;
  bottom: 115px;
  right: 20px;
}

.hands_state>div {
  color: #ffffff;
  width: 87px;
  height: 32px;
  background: url(../../assets/lives/jushouing.png);
  background-size: 100%;
  text-align: left;
  padding-left: 5px;
  line-height: 18px;
}

.hands_state>div>div:first-child {
  width: 56px;
  text-align: center;
  font-size: 12px;
}

.hands_state>div>div:nth-child(2) {
  width: 56px;
  text-align: center;
  font-size: 10px;
}

.hands_state2>div {
  color: #ffffff;
  width: 87px;
  height: 32px;
  background: url(../../assets/lives/lianmaiing.png);
  background-size: 100%;
  text-align: left;
  padding-left: 5px;
  line-height: 18px;
}

.hands_state2>div>div:first-child {
  width: 56px;
  text-align: center;
  font-size: 12px;
}

.hands_state2>div>div:nth-child(2) {
  width: 56px;
  text-align: center;
  font-size: 10px;
}

.giftfk {
  background-color: #ffffff;
  padding: 50px;
  border-radius: 10px;
  height: 240px;
  width: 180px;
  position: fixed;
  z-index: 100;
  top: 30%;
  right: 45%;
}

.mb_giftfk {
  background-color: #000;
  opacity: 0.6;
  border-radius: 10px;
  position: fixed;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  top: 0;
  right: 0;
}

.gift_view {
  color: red;
  font-size: 14px;
  text-align: left;
  width: 80%;
  margin: 10px auto;
}

.gift_tx {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -50px;
}

.falst_enter {
  position: absolute;
  z-index: 99;
  bottom: 90px;
  width: 100%;
}

.falst_enter div {
  float: left;
  border-radius: 11px;
  font-size: 12px;
  margin-left: 2.5%;
  padding: 0px 3%;
  height: 22px;
  line-height: 22px;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.6);
}

.replyDiv {
  background-color: rgba(63, 63, 63, 0.6);
  margin-top: 10px;
  font-size: 13px;
  margin-left: 37px;
  width: fit-content;
  color: #ffffff;
  border-radius: 5px;
  padding: 12px 16px;
}

.replyDiv span {
  color: #ffffff;
  margin-left: 0px;
  font-size: 13px;
}
</style>

<style lang="scss">
.dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1011;
  background-color: rgba(0, 0, 0, 0.5);

  &_detail {
    margin: auto;
    width: 450px;
    max-height: 800px;
    background-color: rgb(255, 255, 255);
    text-align: center;
    z-index: 9977;
    border-radius: 15px;
    color: rgb(0, 0, 0);
    position: relative;
    top: 15%;

    &>img {
      width: 90%;
      height: auto;
    }
  }

  &_title {
    display: inline-block;
    font-size: 14px;
    padding: 10px 0;
  }

  &_btn {
    padding: 15px 0;
    cursor: pointer;
  }
}

.lt_title {
  height: 48px;
  background: #f0f0f0;
  line-height: 48px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.user-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #694ec4;
  display: inline-block;
  color: #fff !important;
  font-size: 10px;
  text-align: center;
  line-height: 30px;
  margin: 0 !important;
}

.blackpopup {
  position: fixed;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background: rgb(242, 242, 242);
  top: 0;
  left: 0;
  color: #a5a5a5;
  padding-top: 200px;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 16px;
}
</style>
